export default __webpack_public_path__ + "static/media/hacksclogo.847bc4ee.png";